import React from 'react';
import ReactPaginate, { ReactPaginateProps } from 'react-paginate';
import './Pagination.scss';

interface IPagination extends Partial<ReactPaginateProps> {
  className?: string;
  isVisible?: boolean;
}

const Pagination: React.FC<IPagination> = React.memo(({ className = '', isVisible = true, ...rest }) => {
  if (!isVisible) {
    return <div />;
  }

  return (
    <ReactPaginate
      containerClassName={`pagination ${className}`}
      activeClassName={'active'}
      breakLabel={<span>...</span>}
      previousLabel=''
      nextLabel=''
      previousLinkClassName='previous-btn'
      nextLinkClassName='next-btn'
      disabledClassName='disable-previous-next-btn'
      breakClassName={'break-me'}
      {...(rest as ReactPaginateProps)}
      marginPagesDisplayed={1}
    />
  );
});

export default Pagination;
